import React from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';

const CookiePolicy = () => {
 
  return (
    <>
      <Header />


<main className="min-h-screen bg-[#0F172A] default-section">
    
    <div className="relative w-full bg-slate-50 py-12 md:py-24">
        <div className="container">
            <div className="">
  <h2 className="text-2xl font-bold underline mb-4">COOKIE POLICY</h2>
  
  <p className="mb-4">
    This Cookie Policy explains how Connecting Traveller ("we", "our", "us") uses cookies and similar tracking technologies to enhance your browsing experience on our website https://www.connectingtraveller.com.
  </p>
  
  <h3 className="text-xl font-semibold mb-4">What are cookies?</h3>
  <p className="mb-4">
    Cookies are small data files that are stored on your device (computer, smartphone, or tablet) when you visit a website. They help the website recognize your device and remember information about your visit, such as your preferences and browsing behavior.
  </p>
  
  <h3 className="text-xl font-semibold mb-4">How we use cookies</h3>
  <p className="mb-4">
    We use cookies to improve our website’s functionality, analyze website traffic, and personalize your experience. Cookies may also be used by third-party service providers for analytics and advertising purposes.
  </p>
  
  <h3 className="text-xl font-semibold mb-4">Types of cookies we use</h3>
  <ul className="list-disc list-inside mb-4">
    <li><strong>Essential Cookies:</strong> Necessary for the basic functions of our website.</li>
    <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our site.</li>
    <li><strong>Advertising Cookies:</strong> Used to serve relevant ads based on your interests.</li>
  </ul>
  
  <h3 className="text-xl font-semibold mb-4">Managing cookies</h3>
  <p className="mb-4">
    You have control over cookies through your web browser settings. You can choose to disable cookies or delete existing cookies. However, disabling cookies may affect your experience on our website and limit some features.
  </p>
  
  <h3 className="text-xl font-semibold mb-4">Your consent</h3>
  <p className="mb-4">
    By continuing to browse our website, you agree to our use of cookies as described in this policy. If you do not agree, please disable cookies in your browser settings.
  </p>
  
  <h3 className="text-xl font-semibold mb-4">Contact us</h3>
  <p className="mb-4">
    If you have any questions about our Cookie Policy, please contact us at <a href="mailto:support@connectingtraveller.com" className="text-blue-600 underline">support@connectingtraveller.com</a>.
  </p>
</div>
        </div>
    </div>

</main>

      <Footer />
    </>
  );
};

export default CookiePolicy;
